import { Result } from 'antd';
import React from 'react';

import { BackButton } from '@client/components/buttons/BackButton';
import { ERoutePaths } from '@client/types/router.type';

const NotFoundPage: React.FC = () => (
  <Result
    status="404"
    title="404"
    subTitle="Sorry, the page you visited does not exist."
    extra={<BackButton route={ERoutePaths.HOME} />}
  />
);

export default NotFoundPage;
